module.exports = __webpack_public_path__ + "media/app/components/CategoryNav/iconsNewDesign/123.7b6fcef0.svg";